import type { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';

import SideBar from '../Login/components/SideBar';

// Shared layout for the guest auth routes (login / forgot-password / password-reset).
// SideBar lives here so it stays mounted while the Outlet swaps forms — otherwise the
// background animation restarts on every navigation between these pages.
function AuthLayout(): ReactElement {
  return (
    <Box className="flex h-screen">
      <SideBar />
      <Box className="container flex">
        <Outlet />
      </Box>
    </Box>
  );
}

export default AuthLayout;
